/* DIREVULF — search bar typing placeholder and voice search sheet.
   Markup and words: snippets/dv-voice-ui.liquid. Styles: dv-voice-ui.css.

   PLACEHOLDER. The empty header search fields show Search "<word>", typed a
   letter at a time, held, then the next word. The words are the store's own
   (fandoms and categories from the main menu). Focus or any typed text hides
   it and gives the field its normal placeholder back.

   VOICE. Every [data-dv-mic] opens the sheet. The click is caught before it
   reaches header.js, so the old in-field listening state never starts; the
   speech recognition itself is the browser's own, as it was. The microphone
   permission is asked inside the tap (some browsers refuse it otherwise) and
   the stream is closed straight away — only speech recognition listens. The
   bars on screen follow the recogniser's own speech events, so the page never
   holds the microphone twice. What was heard is typed into the same form and
   that form is submitted, so results, recent searches and analytics all
   behave exactly as a typed search. */
(function () {
  'use strict';
  if (window.__dvxVoice) return;
  window.__dvxVoice = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var data = {};
  try { data = JSON.parse(($('#dvx-voice-data') || {}).textContent || '{}'); } catch (e) { data = {}; }
  function str(k, f) { return (data && typeof data[k] === 'string' && data[k]) || f || ''; }

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { reduce = false; }

  /* Fandoms and categories taken in turn, so the field alternates between the
     two kinds of thing a shopper looks for. */
  var terms = (function () {
    var a = (data.fandoms || []).filter(Boolean), b = (data.categories || []).filter(Boolean), out = [], seen = {};
    for (var i = 0; i < Math.max(a.length, b.length); i++) {
      [a[i], b[i]].forEach(function (t) {
        if (!t) return;
        var k = String(t).toLowerCase();
        if (seen[k]) return;
        seen[k] = 1; out.push(String(t));
      });
    }
    return out;
  })();

  /* ============================================================ placeholder */
  var fields = [];
  function setupField(input) {
    var form = input.form;
    if (!form || input.__dvx) return;
    input.__dvx = true;
    form.classList.add('dvx-search');
    var native = input.getAttribute('placeholder') || '';
    if (!input.getAttribute('aria-label') && !form.querySelector('label[for="' + input.id + '"]')) {
      input.setAttribute('aria-label', native);
    }
    if (!terms.length) return;
    var ph = document.createElement('span');
    ph.className = 'dvx-ph';
    ph.setAttribute('aria-hidden', 'true');
    ph.innerHTML = '<span class="dvx-ph__lead">' + esc(str('lead', 'Search')) + '</span>&nbsp;<span class="dvx-ph__q"></span>';
    input.insertAdjacentElement('afterend', ph);
    function sync() {
      var on = !input.value && document.activeElement !== input;
      form.classList.toggle('dvx-ph-on', on);
      input.setAttribute('placeholder', on ? '' : native);
    }
    input.addEventListener('focus', sync);
    input.addEventListener('blur', sync);
    input.addEventListener('input', sync);
    fields.push({ q: ph.querySelector('.dvx-ph__q'), sync: sync });
    sync();
  }

  var tIndex = 0, tChars = 0, tTimer = null;
  function paintTerm(term, chars, closed) {
    var shown = term.slice(0, chars);
    var settled = closed ? shown : shown.slice(0, Math.max(0, shown.length - 2));
    var fresh = closed ? '' : shown.slice(settled.length);
    var html = '"' + esc(settled) + (fresh ? '<span class="dvx-ph__new">' + esc(fresh) + '</span>' : '') + (closed ? '"' : '');
    fields.forEach(function (f) { f.q.innerHTML = html; });
  }
  function tick() {
    var term = terms[tIndex % terms.length];
    if (document.hidden) { tTimer = setTimeout(tick, 800); return; }
    if (reduce) {
      paintTerm(term, term.length, true);
      tIndex++;
      tTimer = setTimeout(tick, 3000);
      return;
    }
    if (tChars < term.length) {
      tChars++;
      paintTerm(term, tChars, false);
      tTimer = setTimeout(tick, 55 + Math.random() * 45);
      return;
    }
    paintTerm(term, term.length, true);
    tChars = 0;
    tIndex++;
    tTimer = setTimeout(tick, 1900);
  }

  /* ============================================================ microphones */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 0c.9 6.6 5.4 11.1 12 12-6.6.9-11.1 5.4-12 12-.9-6.6-5.4-11.1-12-12C6.6 11.1 11.1 6.6 12 0z"/></svg>';
  function decorateMic(btn) {
    if (btn.__dvx) return;
    btn.__dvx = true;
    btn.classList.add('dvx-mic');
    var bars = document.createElement('span');
    bars.className = 'dvx-mic__bars';
    bars.setAttribute('aria-hidden', 'true');
    bars.innerHTML = '<i></i><i></i><i></i><i></i><i></i>';
    var spark = document.createElement('span');
    spark.className = 'dvx-mic__spark';
    spark.setAttribute('aria-hidden', 'true');
    spark.innerHTML = SPARK;
    btn.appendChild(bars);
    btn.appendChild(spark);
  }
  /* Now and then the bars dance, to say the button is alive. */
  function danceLoop() {
    if (reduce) return;
    setInterval(function () {
      if (document.hidden) return;
      $$('.dvx-mic').forEach(function (m) {
        m.classList.remove('is-dance');
        void m.offsetWidth;
        m.classList.add('is-dance');
      });
    }, 5200);
  }

  /* ================================================================ sheet */
  var root = null, card, say, stateEl, live, again, meterEl, waveBars;
  var rec = null, form = null, input = null, opener = null;
  var mode = 'idle', finalText = '', interimText = '', talking = false, lastHeard = 0;
  var promptTimer = null, meterTimer = null, maxTimer = null, closeTimer = null, promptIndex = 0;
  var levels = [];
  var METER_BARS = 30;
  var MAX_LISTEN = 12000;

  var prompts = (function () {
    var list = (data.prompts || []).slice();
    var pre = str('tryPrefix', 'Try');
    terms.slice(0, 6).forEach(function (t) { list.push(pre + ' “' + t + '”…'); });
    return list.length ? list : ['…'];
  })();

  function build() {
    root = $('#DvxVoice');
    if (!root) return false;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    card = $('.dvx-voice__card', root);
    say = $('[data-dvx-say]', root);
    stateEl = $('[data-dvx-state]', root);
    live = $('[data-dvx-live]', root);
    again = $('[data-dvx-again]', root);
    meterEl = $('[data-dvx-meter]', root);
    waveBars = $$('[data-dvx-wave] > i', root);
    var html = '';
    for (var i = 0; i < METER_BARS; i++) html += '<i></i>';
    meterEl.innerHTML = html;
    $$('[data-dvx-close]', root).forEach(function (b) { b.addEventListener('click', function () { cancel(); }); });
    $('[data-dvx-done]', root).addEventListener('click', function () { done(); });
    $('[data-dvx-speak]', root).addEventListener('click', function () { begin(); });
    root.addEventListener('keydown', onKey);
    return true;
  }

  function setMode(m, message) {
    mode = m;
    root.setAttribute('data-mode', m);
    var listeningish = m === 'starting' || m === 'listening';
    live.hidden = !listeningish && m !== 'done';
    again.hidden = m !== 'idle';
    if (m === 'starting') stateEl.textContent = str('starting', 'Getting the mic ready…');
    else if (m === 'listening') stateEl.textContent = str('listening', 'Listening…');
    else if (m === 'done') stateEl.textContent = str('searching', 'Searching…');
    else stateEl.textContent = '';
    if (m === 'idle') {
      stopPrompts();
      showSay(message || str('nospeech', ''), 'msg');
    }
  }

  function showSay(text, kind) {
    say.classList.remove('is-in');
    say.setAttribute('data-kind', kind || 'prompt');
    say.textContent = text;
    void say.offsetWidth;
    say.classList.add('is-in');
  }

  function startPrompts() {
    stopPrompts();
    promptIndex = 0;
    showSay(prompts[0], 'prompt');
    promptTimer = setInterval(function () {
      if (interimText || finalText || mode !== 'listening') return;
      promptIndex = (promptIndex + 1) % prompts.length;
      showSay(prompts[promptIndex], 'prompt');
    }, 2600);
  }
  function stopPrompts() { clearInterval(promptTimer); promptTimer = null; }

  /* The live bars: a strip of levels that scrolls in from the right, full
     while the recogniser hears speech, a dotted line while it does not. */
  function startMeter() {
    stopMeter();
    levels = [];
    for (var i = 0; i < METER_BARS; i++) levels.push(0);
    var bars = $$('i', meterEl);
    meterTimer = setInterval(function () {
      var now = Date.now();
      var active = mode === 'listening' && (talking || now - lastHeard < 500);
      var v = active ? 0.25 + Math.random() * 0.75 : 0;
      levels.push(v);
      levels.shift();
      for (var j = 0; j < bars.length; j++) bars[j].style.setProperty('--l', levels[j].toFixed(2));
      root.classList.toggle('is-talking', active);
      for (var k = 0; k < waveBars.length; k++) {
        var h = active ? 0.3 + Math.random() * 0.7 : 0;
        waveBars[k].style.setProperty('--h', h.toFixed(2));
      }
    }, reduce ? 240 : 80);
  }
  function stopMeter() {
    clearInterval(meterTimer); meterTimer = null;
    if (root) root.classList.remove('is-talking');
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('dvx-lock', on);
  }

  function open(mic) {
    if (!root && !build()) return false;
    form = mic.closest('form');
    input = form ? form.querySelector('input[name="q"]') : null;
    if (!form || !input) return false;
    opener = mic;
    clearTimeout(closeTimer);
    root.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }
    startMeter();
    begin();
    return true;
  }

  function teardownRec() {
    clearTimeout(maxTimer);
    if (rec) {
      rec.onstart = rec.onresult = rec.onerror = rec.onend = rec.onspeechstart = rec.onspeechend = rec.onsoundstart = rec.onsoundend = null;
      try { rec.abort(); } catch (e) { /* already finished */ }
      rec = null;
    }
  }

  function close() {
    teardownRec();
    stopPrompts();
    stopMeter();
    root.classList.remove('is-open');
    lockScroll(false);
    closeTimer = setTimeout(function () { root.hidden = true; }, reduce ? 0 : 280);
  }

  function cancel() {
    close();
    if (opener) { try { opener.focus({ preventScroll: true }); } catch (e) { /* gone */ } }
  }

  /* ✓: stop listening; whatever was heard is searched when the recogniser
     hands it back (onend). */
  function done() {
    if (mode === 'listening' && rec) {
      try { rec.stop(); } catch (e) { finish(finalText || interimText); }
      return;
    }
    if (mode === 'starting') { cancel(); return; }
  }

  function finish(text) {
    text = (text || '').trim();
    teardownRec();
    if (!text) { setMode('idle', str('nospeech', '')); return; }
    setMode('done');
    stopPrompts();
    showSay('“' + text + '”', 'heard');
    setTimeout(function () {
      input.value = text;
      try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) { /* old browser */ }
      close();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }, reduce ? 150 : 650);
  }

  function begin() {
    teardownRec();
    finalText = ''; interimText = ''; talking = false; lastHeard = 0;
    setMode('starting');
    startPrompts();
    /* The permission prompt, inside the tap. The stream itself is not used. */
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      var asking;
      try { asking = navigator.mediaDevices.getUserMedia({ audio: true }); }
      catch (e) { startRec(); return; }
      asking.then(function (stream) {
        try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (e) { /* nothing to stop */ }
        if (mode === 'starting' && !root.hidden) startRec();
      }, function (err) {
        var name = err && err.name;
        if (name === 'NotAllowedError' || name === 'SecurityError' || name === 'PermissionDeniedError') {
          setMode('idle', str('denied', '')); return;
        }
        if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
          setMode('idle', str('error', '')); return;
        }
        if (mode === 'starting' && !root.hidden) startRec();
      });
    } else {
      startRec();
    }
  }

  function startRec() {
    try { rec = new SR(); } catch (e) { setMode('idle', str('error', '')); return; }
    rec.lang = document.documentElement.lang && document.documentElement.lang.indexOf('-') > 0 ? document.documentElement.lang : 'en-IN';
    rec.interimResults = true;
    rec.maxAlternatives = 1;
    rec.continuous = false;
    rec.onstart = function () {
      setMode('listening');
      maxTimer = setTimeout(function () { if (rec) { try { rec.stop(); } catch (e) { /* done */ } } }, MAX_LISTEN);
    };
    rec.onsoundstart = rec.onspeechstart = function () { talking = true; lastHeard = Date.now(); };
    rec.onsoundend = rec.onspeechend = function () { talking = false; };
    rec.onresult = function (event) {
      var fin = '', interim = '';
      for (var i = 0; i < event.results.length; i++) {
        var r = event.results[i];
        if (r.isFinal) fin += r[0].transcript;
        else interim += r[0].transcript;
      }
      lastHeard = Date.now();
      if (fin) finalText = fin.trim();
      interimText = (fin + interim).trim();
      if (interimText) {
        stopPrompts();
        say.setAttribute('data-kind', 'heard');
        say.textContent = interimText;
      }
    };
    rec.onerror = function (event) {
      var code = event && event.error;
      if (code === 'aborted') return;
      teardownRec();
      if (code === 'not-allowed' || code === 'service-not-allowed') { setMode('idle', str('denied', '')); return; }
      if (code === 'no-speech') { setMode('idle', str('nospeech', '')); return; }
      if (finalText || interimText) { finish(finalText || interimText); return; }
      setMode('idle', str('error', ''));
    };
    rec.onend = function () {
      if (!rec) return;
      finish(finalText || interimText);
    };
    try { rec.start(); }
    catch (e) { setMode('idle', str('error', '')); }
  }

  /* Escape closes; Tab stays inside the sheet. */
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); cancel(); return; }
    if (e.key !== 'Tab') return;
    var items = $$('button:not([hidden])', root).filter(function (b) { return b.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* Caught on the way down, before header.js's own handler on the button. */
  document.addEventListener('click', function (e) {
    if (!SR) return;
    var mic = e.target && e.target.closest ? e.target.closest('[data-dv-mic]') : null;
    if (!mic) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open(mic);
  }, true);

  function init() {
    $$('form.header-search input[type="search"], form.mobile-search input[type="search"]').forEach(setupField);
    $$('[data-dv-mic]').forEach(decorateMic);
    if (terms.length && fields.length) tick();
    danceLoop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
